import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '../../atoms';
import { H2, H4 } from 'components/core/Typography';
import { Section } from 'components/core/Page';
import { Image } from 'components/core/Image';
import { Link } from 'components/core/Link';
import states from '../../../config/states';
import { toKebabCase } from '../../../lib/helpers';
import AccordionItem from '../../atoms/Accordion/AccordionItem';
import SizesSS from '../../../assets/images/icons/psp/accordion/SizesSS.svg';
import VehicleSS from '../../../assets/images/icons/psp/accordion/VehicleSS.svg';
import AmenitiesSS from '../../../assets/images/icons/psp/accordion/AmenitiesSS.svg';
import RightArrow from '../../../assets/images/icons/psp/accordion/RightArrow.svg';
import './CityCard.scss';
import { storageMap } from './storageMap';

const CityCard = ({ cityData }) => {
	const { city = '', state = '', content = {} } = cityData || {};
	const {
		unitTypes = [],
		vehicleStorage = [],
		amenities = [],
	} = content || {};
	const title = `${city}, ${state}`;

	const renderDetailsList = (details) => (
		<div className="item-details-list">
			{(details || []).map((item, index) => {
				const matched = storageMap.find((t) =>
					item?.text?.includes(t.key),
				);

				const result = matched
					? `${matched.label} in ${city}, ${state}`
					: item?.text;
				return (
					<div
						key={item?.uri || `detail-${index}`}
						className="item-detail"
					>
						<Link href={`/${item?.uri}`}>
							<H4 className="item-detail-label">{result}</H4>
						</Link>
						<Image
							src={RightArrow}
							className="right-arrow-icon"
						/>
					</div>
				);
			})}
		</div>
	);

	return (
		<Section className="city-card">
			<div className="city-card__header">
				<H2 className="city-card__title">{title}</H2>
			</div>
			<div className="city-card__content">
				<AccordionItem
					question={'Self Storage Amenities'}
					contentNode={renderDetailsList(amenities)}
					titleIcon={AmenitiesSS}
				/>
				<AccordionItem
					question={'Self Storage Sizes'}
					contentNode={renderDetailsList(unitTypes)}
					titleIcon={SizesSS}
				/>
				<AccordionItem
					question={'Vehicle Self Storage'}
					contentNode={renderDetailsList(vehicleStorage)}
					titleIcon={VehicleSS}
				/>
			</div>
			<Button
				href={`/self-storage/${toKebabCase(states[state] || state)}/${toKebabCase(city)}`}
				className="city-card__button"
			>{`View all self storage in ${city}, ${state}`}</Button>
		</Section>
	);
};

CityCard.propTypes = {
	cityData: PropTypes.shape({
		city: PropTypes.string,
		state: PropTypes.string,
		content: PropTypes.shape({
			unitTypes: PropTypes.array,
			vehicleStorage: PropTypes.array,
			amenities: PropTypes.array,
		}),
	}),
};

export default CityCard;
